<app-loader *ngIf="isLoading || manualInvoicesLoading || prepaidManualInvoicesLoading" ></app-loader>
<p-panel *ngIf="!isLoading && !manualInvoicesLoading && !prepaidManualInvoicesLoading" [header]="'invoicesH2' | translate" >


<h3> </h3>

<p-table [class]="'nuty-border'" [value]="this.prepaidManualInvoices" *ngIf="prepaidManualInvoices && prepaidManualInvoices.length > 0">
    <ng-template pTemplate="header">
        <tr>
            <th class="colTitle" style="width:35%;text-align: left;">Nazwa</th>
            <th class="colTitle" style="width:25%;text-align: left;">Data dodania</th>
            <th class="colTitle" style="width:20%;text-align: left;">Doładowanie</th>
            <th class="colTitle" style="width:20%;text-align: left;">Akcja</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-invoice>
        <tr>
            <td style="width:35%; text-decoration: underline; cursor: pointer;"
                (click)="downloadPrepaidManualInvoice(invoice)">{{invoice.original_name}}</td>
            <td style="width:25%">{{invoice?.created_at | date:'dd.MM.yyyy, HH:mm' }}</td>
            <td style="width:20%">Doładowanie konta #{{invoice?.prepaid_id}}</td>
            <td style="width:20%">
                <button pButton type="button" class="ui-button-secondary" label="Pobierz"
                    (click)="downloadPrepaidManualInvoice(invoice)"></button>
            </td>
        </tr>
    </ng-template>
</p-table>

<h3> </h3>

<p-table [class]="'nuty-border'" [value]="this.manualInvoices" *ngIf="manualInvoices && manualInvoices.length > 0">
    <ng-template pTemplate="header">
        <tr>
            <th class="colTitle" style="width:35%;text-align: left;">Nazwa</th>
            <th class="colTitle" style="width:25%;text-align: left;">Data dodania</th>
            <th class="colTitle" style="width:20%;text-align: left;">{{'invocies_order' | translate}}</th>
            <th class="colTitle" style="width:20%;text-align: left;">Akcja</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-invoice>
        <tr>
            <td style="width:35%; text-decoration: underline; cursor: pointer;"
                (click)="downloadManualInvoice(invoice)">{{invoice.original_name}}</td>
            <td style="width:25%">{{invoice?.created_at | date:'dd.MM.yyyy, HH:mm' }}</td>
            <td style="width:20%">{{invoice?.order_id}}</td>
            <td style="width:20%">
                <button pButton type="button" class="ui-button-secondary" label="Pobierz"
                    (click)="downloadManualInvoice(invoice)"></button>
            </td>
        </tr>
    </ng-template>
</p-table>


<h3> </h3>

<p-table [class]="'nuty-border'" [value]="this.invoices" *ngIf="!isLoading && invoices && invoices.length > 0">
    <ng-template pTemplate="header">
        <tr>
            <th class="colTitle" style="width:25%;text-align: left;">{{'invoices_no_number' | translate}}</th>
            <th class="colTitle" style="width:25%;text-align: left;">{{'invocies_date' | translate}}</th>
            <th class="colTitle" style="width:25%;text-align: left;">{{'invocies_order' | translate}}</th>
            <th class="colTitle" style="width:25%;text-align: left;">{{'invocies_total_amount' | translate}}</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-invoice>
        <tr>
            <td style="width:25%" style="text-decoration: underline;cursor: pointer;"
                (click)="downloadInvoice(invoice)">{{invoice.invoice_number_full}}</td>
            <td style="width:25%">{{invoice?.created_at | date:'dd.MM.yyyy, HH:mm' }}</td>
            <td style="width:25%">{{(invoice.order_id) ? invoice.order_id :  'invoices_prepaid' | translate }}</td>
            <td style="width:25%">
                {{invoice?.total_amount | currencyReduce: true: ((invoice.order) ? invoice.order?.currency_histories?.exchange_rate : 1) | currency: ((invoice.order) ? invoice.order?.currency_histories?.currency?.currency_code : "PLN") }}
            </td>
        </tr>
    </ng-template>
</p-table>

<div *ngIf="this.invoices.length == 0" style="display: flex;justify-content: center; margin-bottom: 20px;">{{'no_invoices' | translate}}<br/><br/></div>


<app-loader *ngIf="isLoading || manualInvoicesLoading || prepaidManualInvoicesLoading"></app-loader>
<div style="height: 30px;"></div>
<p-paginator (onPageChange)="this.onPaginate($event)" *ngIf="!isLoading && invoices.length > 0" [rows]="data.per_page"
    [totalRecords]="data.total"></p-paginator>
</p-panel>
